import(/* webpackMode: "eager" */ "/codebuild/output/src1355440236/src/src/app/travelCardList/page.tsx");
